/**
 * @param {unknown} raw
 * @returns {{ fromPct: number, toPct: number } | null}
 */
export function parseExploreUnknownBossRetryDarknessMeter(raw) {
  if (raw == null || typeof raw !== 'object') {
    return null;
  }
  const fromPct = Number(raw.fromPct);
  const toPct = Number(raw.toPct);
  if (!Number.isFinite(fromPct) || !Number.isFinite(toPct)) {
    return null;
  }
  return {
    fromPct: Math.max(0, Math.min(100, fromPct)),
    toPct: Math.max(0, Math.min(100, toPct)),
  };
}

export function computeExploreUnknownDarknessLossFillFromPct(runDarknessPercent, memoryDarknessReductionTotal) {
  if (typeof runDarknessPercent !== 'number' || Number.isNaN(runDarknessPercent)) {
    throw new Error(
      'computeExploreUnknownDarknessLossFillFromPct: runDarknessPercent must be a finite number'
    );
  }
  if (
    typeof memoryDarknessReductionTotal !== 'number' ||
    Number.isNaN(memoryDarknessReductionTotal)
  ) {
    throw new Error(
      'computeExploreUnknownDarknessLossFillFromPct: memoryDarknessReductionTotal must be a finite number'
    );
  }

  const fromPct = Math.max(0, Math.min(100, runDarknessPercent - memoryDarknessReductionTotal));
  return fromPct;
}
